import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=f53aa16a&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f53aa16a')) {
      api.createRecord('f53aa16a', component.options)
    } else {
      api.reload('f53aa16a', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=f53aa16a&", function () {
      api.rerender('f53aa16a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dpxi6rDZta8R/JS/offershelp.vue"
export default component.exports